import styled from "styled-components";

export const HomePage = styled.div`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;

  :root {
    --primary: #ffc107;
    --primary-dark: #ffa000;
    --secondary: #2196f3;
    --dark: #121826;
    --light: #f8f9fa;
    --gray: #6c757d;
    --success: #4caf50;
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  /* 头部样式 */
  header {
    background-color: white;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    position: sticky;
    top: 0;
    z-index: 100;
  }

  .header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
  }

  .logo {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .logo h1 {
    font-size: 1.8rem;
    font-weight: 800;
    color: var(--primary-dark);
  }

  .logo span {
    color: var(--secondary);
  }

  nav ul {
    display: flex;
    list-style: none;
    gap: 30px;
  }

  nav a {
    text-decoration: none;
    color: var(--dark);
    font-weight: 600;
    font-size: 1.1rem;
    transition: color 0.3s;
  }

  nav a:hover {
    color: var(--secondary);
  }

  .cta-button {
    background: linear-gradient(to right, var(--primary), var(--primary-dark));
    color: var(--dark);
    padding: 10px 25px;
    border-radius: 30px;
    font-weight: 700;
    text-decoration: none;
    display: inline-block;
    transition: transform 0.3s, box-shadow 0.3s;
    border: none;
    cursor: pointer;
    font-size: 1.1rem;
  }

  .cta-button:hover {
    transform: translateY(-3px);
    box-shadow: 0 5px 15px rgba(255, 168, 0, 0.4);
  }

  /* 英雄区域 */
  .hero {
    background: linear-gradient(135deg, #1a2a6c, #b21f1f, #1a2a6c);
    color: white;
    padding: 80px 0;
    position: relative;
    overflow: hidden;
  }

  .hero::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none"><path d="M0,0 L100,0 L100,100 Z" fill="rgba(255,255,255,0.1)"/></svg>');
    background-size: cover;
    opacity: 0.2;
  }

  .hero-content {
    max-width: 650px;
    position: relative;
    z-index: 2;
  }

  .hero h1 {
    font-size: 3.5rem;
    font-weight: 800;
    line-height: 1.2;
    margin-bottom: 20px;
  }

  .hero h1 span {
    color: var(--primary);
  }

  .hero p {
    font-size: 1.3rem;
    margin-bottom: 30px;
    max-width: 600px;
  }

  .hero-buttons {
    display: flex;
    gap: 20px;
    margin-top: 30px;
  }

  .secondary-button {
    background: transparent;
    color: white;
    border: 2px solid white;
    padding: 10px 25px;
    border-radius: 30px;
    font-weight: 700;
    text-decoration: none;
    transition: background 0.3s;
  }

  .secondary-button:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  /* 功能区域 */
  .features {
    padding: 100px 0;
    background-color: white;
  }

  .section-title {
    text-align: center;
    margin-bottom: 60px;
  }

  .section-title h2 {
    font-size: 2.5rem;
    color: var(--dark);
    margin-bottom: 15px;
  }

  .section-title p {
    color: var(--gray);
    font-size: 1.2rem;
    max-width: 700px;
    margin: 0 auto;
  }

  .features-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 40px;
  }

  .feature-card {
    background: var(--light);
    border-radius: 15px;
    padding: 30px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    transition: transform 0.3s;
    text-align: center;
  }

  .feature-card:hover {
    transform: translateY(-10px);
  }

  .feature-icon {
    font-size: 3rem;
    color: var(--secondary);
    margin-bottom: 20px;
  }

  .feature-card h3 {
    font-size: 1.5rem;
    margin-bottom: 15px;
    color: var(--dark);
  }

  /* 发币流程 */
  .process {
    padding: 100px 0;
    background: linear-gradient(to bottom, #f8f9fa, #e9ecef);
  }

  .steps {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 30px;
    margin-top: 50px;
  }

  .step {
    background: white;
    border-radius: 15px;
    padding: 30px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    max-width: 250px;
    text-align: center;
    position: relative;
  }

  .step-number {
    position: absolute;
    top: -20px;
    left: 50%;
    transform: translateX(-50%);
    background: var(--primary);
    color: var(--dark);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 800;
    font-size: 1.2rem;
  }

  .step h3 {
    margin: 20px 0 15px;
    color: var(--dark);
  }

  /* CTA区域 */
  .cta-section {
    padding: 100px 0;
    background: linear-gradient(135deg, var(--secondary), #0d47a1);
    color: white;
    text-align: center;
  }

  .cta-section h2 {
    font-size: 2.5rem;
    margin-bottom: 20px;
  }

  .cta-section p {
    font-size: 1.2rem;
    max-width: 700px;
    margin: 0 auto 30px;
  }

  /* 常见问题 */
  .faq {
    padding: 100px 0;
    background: white;
  }

  .faq-container {
    max-width: 800px;
    margin: 0 auto;
  }

  .faq-item {
    margin-bottom: 20px;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
  }

  .faq-question {
    background: var(--light);
    padding: 20px;
    font-weight: 700;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.2rem;
  }

  .faq-answer {
    padding: 0 20px;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease, padding 0.3s ease;
  }

  .faq-item.active .faq-answer {
    padding: 20px;
    max-height: 500px;
  }

  /* 页脚 */
  footer {
    background: var(--dark);
    color: white;
    padding: 60px 0 30px;
  }

  .footer-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 40px;
    margin-bottom: 40px;
  }

  .footer-column h3 {
    font-size: 1.3rem;
    margin-bottom: 20px;
    color: var(--primary);
  }

  .footer-links {
    list-style: none;
  }

  .footer-links li {
    margin-bottom: 10px;
  }

  .footer-links a {
    color: #ddd;
    text-decoration: none;
    transition: color 0.3s;
  }

  .footer-links a:hover {
    color: var(--primary);
  }

  .social-links {
    display: flex;
    gap: 15px;
    margin-top: 20px;
  }

  .social-links a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    color: white;
    transition: background 0.3s;
  }

  .social-links a:hover {
    background: var(--primary);
  }

  .copyright {
    text-align: center;
    padding-top: 30px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    color: #aaa;
  }

  /* 响应式设计 */
  @media (max-width: 768px) {
    .header-container {
      flex-direction: column;
      gap: 20px;
    }

    .hero h1 {
      font-size: 2.5rem;
    }

    .hero p {
      font-size: 1.1rem;
    }

    .hero-buttons {
      flex-direction: column;
      gap: 15px;
    }

    .steps {
      flex-direction: column;
      align-items: center;
    }
  }
`;
